import { useEffect } from 'react';

import type { UseEmailLogsEffectsProps } from '@app/pages/EmailLogs/types';

export const useEmailLogsEffects = ({
  handleGetEmailLogs,
  defaultFilters,
  defaultPage,
  defaultPageSize,
}: UseEmailLogsEffectsProps) => {
  useEffect(() => {
    handleGetEmailLogs({
      filters: defaultFilters,
      page: defaultPage,
      pageSize: defaultPageSize,
    });
  }, [defaultFilters, defaultPage, defaultPageSize, handleGetEmailLogs]);
};
